import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { registerSessionGuard } from '@/lib/session-guard';
import { App } from './App';
import './styles/index.css';

// Manejo global de 401: antes del primer render, para que cualquier petición que devuelva
// 401 (token expirado/inválido) limpie la sesión y mande a /login.
registerSessionGuard();

const container = document.getElementById('root');

if (!container) {
  throw new Error('No se encontró el elemento #root en index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
